export enum ComponentsCustomerType {
    B2C = "B2C",
    B2B = "B2B"
}
